<template>
	<div class="settings">
		<b-container class="bv-example-row">
			<b-card header-tag="header" footer-tag="footer">
				<div slot="header" class="top-card">
						<span>
							<h5>{{$t('sidebar.pos.settings')}}</h5>
						</span>
				</div>
				<b-row class="frame-setting">
					<b-col col lg="4" md="6" sm="12">
						<div class="cashbox">
							<h4>Касса раками:</h4>
							<span class="cashboxnumber">{{kassaName}}</span>
						</div>
					</b-col>
					<b-col col lg="4" md="6" sm="12">
						<!--<b-form-input-->
							<!--type="number"-->
							<!--autocomplete="off"-->
							<!--:placeholder="$t('posSettings.number')"-->
							<!--@click="$event.target.select()"-->
							<!--@keyup.enter="saveCachBoxNumber"-->
							<!--v-model="cashboxnumber"-->
							<!--min="0"-->
						<!--&gt;-->
						<!--</b-form-input>-->
						<b-form-select v-model="kassaName"
									   :plain="false"
									   :options="getRefChildren"
									   size="sm"
									   label-for="Position"
									   :required="true"
									   :text-field="'name'"
									   :value-field="'code'"
						>
							<template slot="first">
								<option :value="null" disabled>
									--{{$t('posSettings.selectMessage')}}--
								</option>
							</template>
						</b-form-select>
						<div class="btn-frame">
							<b-button variant="outline-info" @click.prevent="saveCachBoxNumber">
								<i class="fa fa-save"></i> &nbsp;
								<span>{{$t('actions.save')}}</span>
							</b-button>
						</div>
					</b-col>
					<b-col v-if="show">
						<b-alert variant="success" class="success-save" :show="show">
							{{$t('posSettings.successMessage')}}
						</b-alert>
					</b-col>
					<b-col v-if="errorShow">
						<b-alert variant="danger" class="success-save" :show="errorShow">
							{{$t('posSettings.errorMessage')}}
						</b-alert>
					</b-col>
				</b-row>
			</b-card>
		</b-container>
	</div>
</template>


<script>
import {TokenService} from "../../../services/storage.service";
import {mapActions, mapGetters} from 'vuex'

export default{
		data(){
			return{
				cashboxnumber:'',
				show:false,
				errorShow:false,
				kassaName:null,
				cashboxName:''
			}
		},
		async created(){
			// referenceschildren
			await this.getReferenceChildren('kassa')

			//
			this.CashBoxNumber()
			// window.localStorage.removeItem('cashboxnumber')
		},
		computed:{
			...mapGetters('references', [
				'getRefChildren',
			]),
		},
		methods:{
			...mapActions('references', [
				'getReferenceChildren',
			]),
			saveCachBoxNumber(){
				if(this.kassaName !== null){
					TokenService.saveCashBoxNumber(this.kassaName)
					this.show = true
					this.errorShow = false
					this.CashBoxNumber()
					setTimeout(()=>{
						this.show = false
					}, 2000);
					this.$router.push('/point-of-sale/pos')

				}else{
					this.errorShow = true
					setTimeout(()=>{
						this.errorShow = false
					}, 2000);
				}
			},
			CashBoxNumber(){
				const cashbox = localStorage.getItem('cash_number')
				this.kassaName = cashbox
			}
		}
	}
</script>

<style scoped>
	.btn-frame{
		display: flex;
		justify-content: flex-end;
		margin-top: 10px;
	}
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		/* display: none; <- Crashes Chrome on hover */
		-webkit-appearance: none;
		margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
	}

	input[type=number] {
		-moz-appearance:textfield; /* Firefox */
	}
	.cashbox{
		display: flex;
		justify-content: center;
	}
	.cashboxnumber{
		font-size: 20px;
		margin-bottom: 4px;
		margin-left: 10px;
	}
	.success-save{
		display: flex;
		justify-content: center;
		padding: 8px;
	}
</style>
